<template>
  <div
    v-match-heights="{
      el: [
        '.stat-box',
        '.bottom-box',
        '.bi-table-card--items',
        'h2.small',
        'h2.middle-line',
        'h2.lower-line'
      ] // Array of selectors to fix
    }"
    class="bi-layout"
  >
    <div class="vx-row lg:mb-8">
      <div class="vx-col w-full">
        <comparison-time-frame-input-dashboard
          v-model="cardsTime"
        ></comparison-time-frame-input-dashboard>
      </div>
    </div>
    <div class="vx-row lg:mb-6">
      <div class="vx-col w-full xl:w-1/4 mb-4">
        <BiStatisticsCard
          icon="fa-mouse"
          data="clicks"
          title="Klicks"
          small
          type="ALL"
          :limit-days="cardsTime.timeframe.from"
          :limit-stop="cardsTime.timeframe.to"
          :compare-start="cardsTime.compareTo.from"
          :compare-stop="cardsTime.compareTo.to"
        />
      </div>
      <div class="vx-col w-full xl:w-1/4 mb-4">
        <BiStatisticsCard
          icon="fa-percentage"
          data="applications"
          title="Bewerbungen"
          small
          type="ALL"
          :limit-days="cardsTime.timeframe.from"
          :limit-stop="cardsTime.timeframe.to"
          :compare-start="cardsTime.compareTo.from"
          :compare-stop="cardsTime.compareTo.to"
        />
      </div>
      <div class="vx-col w-full xl:w-1/4 mb-4">
        <BiStatisticsCard
          icon="fa-euro-sign"
          data="cost"
          title="Budgetverbrauch"
          small
          type="ALL"
          :limit-days="cardsTime.timeframe.from"
          :limit-stop="cardsTime.timeframe.to"
          :compare-start="cardsTime.compareTo.from"
          :compare-stop="cardsTime.compareTo.to"
        />
      </div>
      <div class="vx-col w-full xl:w-1/4 mb-4">
        <BiStatisticsCard
          icon="fa-percentage"
          data="costPerApplication"
          title="Kosten pro Bewerbung"
          small
          type="ALL"
          :limit-days="cardsTime.timeframe.from"
          :limit-stop="cardsTime.timeframe.to"
          :compare-start="cardsTime.compareTo.from"
          :compare-stop="cardsTime.compareTo.to"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2 mb-10">
        <h2 class="small">Auswertung der Kennzahlen</h2>
        <div class="bi-table-card graph">
          <div class="bi-table-card-header">
            <div class="bi-table-card-header-title">
              Impressionen ausgewählt
            </div>
            <div class="bi-table-card-header-action">
              <DataInput
                v-model="filter.object"
                type="select"
                :options="[
                  { code: 'IMPRESSIONS', label: 'Impressionen' },
                  { code: 'CLICKS', label: 'Klicks' },
                  { code: 'COST', label: 'Ausgegebener Betrag' },
                  { code: 'APPLICATIONS', label: 'Bewerbungen' }
                ]"
                placeholder="Kennzahl wählen"
                name="object"
              />
            </div>
          </div>
          <DashboardMetricChart
            :header="filter.object"
            :chart-data="metricStatsDataset"
          />
        </div>
      </div>
      <div class="vx-col w-full lg:w-1/2 mb-10">
        <h2 class="small">Quellenaufteilung</h2>
        <div class="bi-table-card graph">
          <div class="bi-table-card-header">
            <div class="bi-table-card-header-title">Budget ausgewählt</div>
            <div class="bi-table-card-header-action">
              <DataInput
                v-model="filter.channel"
                type="select"
                :options="[
                  { code: 'CTR', label: 'CTR' },
                  {
                    code: 'COST_PER_APPLICATION',
                    label: 'Kosten pro Bewerber'
                  },
                  { code: 'CPC', label: 'CPC' }
                ]"
                placeholder="Kennzahl wählen"
                name="channel"
              />
            </div>
            <DashboardSourceChart
              class="w-full"
              :header="filter.channel"
              :chart-data="sourceStatsDataset"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col lg:w-1/3 mb-10">
        <h2 class="middle-line">
          Letzte Bewerbungen ({{
            (
              recentlySpent / (newApplications ? newApplications : 1)
            ).toLocaleString(undefined, {
              type: "currency",
              currency: "EUR"
            })
          }}€/Bewerber) {{ betweenDatesText }}
        </h2>
        <BiTableCardApplications
          :start-date="cardsTime.timeframe.from"
          :end-date="cardsTime.timeframe.to"
          @retrieved="updateNewApplications"
        />
      </div>
      <div class="vx-col lg:w-1/3 mb-10">
        <h2 class="middle-line">TOP 8 Stellen {{ betweenDatesText }}</h2>
        <BiTableCardTopVacancies
          :start-date="cardsTime.timeframe.from"
          :end-date="cardsTime.timeframe.to"
        />
      </div>
      <div class="vx-col lg:w-1/3">
        <h2 class="middle-line">Populärste Kanäle {{ betweenDatesText }}</h2>
        <div class="bi-table-card stat-box">
          <table class="bi-dashboard-table-channels">
            <tr v-for="channel in topChannels" :key="channel.identifier">
              <th>
                {{ applicantSources[channel.identifier] }}
              </th>
              <td>
                {{ channel.number }}
              </td>
            </tr>
          </table>

          <DashboardTopChannelsChart
            class="w-full"
            :header="filter.channel"
            :chart-data="popularChannelsDataset"
          />
        </div>
      </div>
      <div class="vx-col lg:w-1/3 mb-10">
        <h2 class="lower-line">Aktuelle Kampagnen</h2>
        <BiTableCard />
      </div>
      <div class="vx-col lg:w-2/3 mb-10">
        <h2 class="lower-line">
          Verteilung der meisten Bewerbung auf Niederlassungen
          {{ betweenDatesText }}
        </h2>
        <BiTableCardUserGroups
          :start-date="cardsTime.timeframe.from"
          :end-date="cardsTime.timeframe.to"
          :number="5"
        />
      </div>
    </div>
  </div>
</template>

<script>
import dataDefaults from "../../assets/utils/dataDefaults";
import moment from "moment";
import BiStatisticsCard from "@/components/bi/BiStatisticsCard.vue";
import BiTableCard from "@/components/bi/BiTableCard.vue";
import BiTableCardApplications from "@/components/bi/BiTableCardApplications.vue";
import BiTableCardTopVacancies from "../../components/bi/BiTableCardTopVacancies.vue";
import BiTableCardUserGroups from "@/components/bi/BiTableCardUserGroups.vue";
import gql from "graphql-tag";
import ComparisonTimeFrameInputDashboard from "../../components/bi/ComparisonTimeFrameInputDashboard.vue";
import DataInput from "@/components/ui/DataInput";
import color from "../../assets/utils/color";
import DashboardMetricChart from "./DashboardMetricChart.js";
import DashboardSourceChart from "./DashboardSourceChart.js";
import DashboardTopChannelsChart from "./DashboardTopChannelsChart.js";

export default {
  components: {
    BiStatisticsCard,
    BiTableCard,
    BiTableCardApplications,
    BiTableCardTopVacancies,
    BiTableCardUserGroups,
    ComparisonTimeFrameInputDashboard,
    DataInput,
    DashboardMetricChart,
    DashboardSourceChart,
    DashboardTopChannelsChart
  },
  data() {
    return {
      newApplications: 0,
      recentlySpent: 0,
      cardsTime: Object.assign(dataDefaults.timeFrameInput(), {
        timeframe: {
          from: moment()
            .subtract(2, "days")
            .startOf("day"),
          to: moment()
            .subtract(1, "days")
            .startOf("day")
        }
      }),
      filter: {
        channel: "CTR",
        object: "IMPRESSIONS"
      },
      metricStatsDataset: null,
      sourceStatsDataset: null
    };
  },
  computed: {
    betweenDatesText() {
      if (!this.cardsTime.timeframe.from) {
        return "";
      }
      return `zwischen dem ${this.cardsTime.timeframe.from.format(
        "DD.MM.YYYY"
      )} und dem ${this.cardsTime.timeframe.to.format("DD.MM.YYYY")}`;
    },
    popularChannelsDataset() {
      let data = [];
      let labels = [];
      let backgroundColor = [];
      let hoverBackgroundColor = [];
      if (this.topChannels) {
        for (const channel of this.topChannels) {
          const label = this.applicantSources[channel.identifier];
          if (!label) {
            continue;
          }
          labels.push(label);
          backgroundColor.push(color.colorFromString(label, 0.8));
          hoverBackgroundColor.push(color.colorFromString(label));
          data.push(channel.number);
        }
      }
      return {
        datasets: [
          {
            data,
            backgroundColor,
            hoverBackgroundColor
          }
        ],
        labels
      };
    }
  },
  watch: {
    cardsTime: function() {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("matchheight", {}));
      }, 650);
    }
  },
  async mounted() {
    let { data } = await this.$apollo.query({
      query: gql`
        query adCampaignStats($filter: AdCampaignStatFilter!) {
          adCampaignStats(filter: $filter) {
            totalCost
          }
        }
      `,
      variables: {
        filter: {
          type: "ALL",
          byDate: true,
          timeFilter: {
            fromTime: moment().subtract(7, "days"),
            months: false
          }
        }
      }
    });
    //console.log(data.adCampaignStats.totalCost)
    this.recentlySpent = data.adCampaignStats.totalCost;
    this.$nextTick(function() {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("matchheight", {}));
      }, 650);
    });
  },
  methods: {
    updateNewApplications(value) {
      this.newApplications = value;
    }
  },
  apollo: {
    topChannels: {
      query: gql`
        query TopChannels(
          $start: Time
          $end: Time
          $number: Int!
          $type: TopNType!
          $metric: TopNMetric!
        ) {
          topNInfo(
            number: $number
            start: $start
            end: $end
            type: $type
            metric: $metric
          ) {
            number
            identifier
          }
        }
      `,
      variables() {
        return {
          metric: "APPLICATIONS",
          type: "CHANNEL",
          number: 5,
          start: this.cardsTime.timeframe.from,
          end: this.cardsTime.timeframe.to
        };
      },
      update: data => data.topNInfo,
      fetchPolicy: "network-only"
    },
    applicantSources: {
      query: gql`
        query ApplicantSources($page: Int!, $size: Int) {
          applicantSources(page: $page, size: $size) {
            results {
              id
              name
            }
          }
        }
      `,
      variables() {
        return {
          page: 1,
          size: 1000 //all sources in one response
        };
      },
      update(data) {
        let sources = {};
        for (let source of data.applicantSources.results) {
          sources[source.id] = source.name;
        }
        return sources;
      }
    },
    dashboardStatsByMetric: {
      query: gql`
        query DashboardStatsByMetric($input: DashboardStatFilter!) {
          dashboardStatsByMetric(input: $input) {
            labels
            data {
              label
              stack
              data
            }
          }
        }
      `,
      variables() {
        return {
          input: {
            metric: this.filter.object,
            timeframe: {
              fromTime: this.cardsTime.timeframe.from,
              toTime: this.cardsTime.timeframe.to
            },
            compareTo:
              this.cardsTime.compareTo.from && this.cardsTime.compareTo.to
                ? {
                    fromTime: this.cardsTime.compareTo.from,
                    toTime: this.cardsTime.compareTo.to
                  }
                : undefined
          }
        };
      },
      fetchPolicy: "network-only",
      update(data) {
        this.metricStatsDataset = {
          datasets: data.dashboardStatsByMetric.data.map(x => {
            x.backgroundColor = colorFromLabel(x.label);
            x.stack = String(x.stack);
            return x;
          }),
          labels: data.dashboardStatsByMetric.labels
        };
      }
    },
    fractionalDashboardStats: {
      query: gql`
        query FractionalDashboardStats($input: DashboardStatFilter!) {
          fractionalDashboardStats(input: $input) {
            labels
            data {
              label
              stack
              data
            }
          }
        }
      `,
      variables() {
        return {
          input: {
            metric: this.filter.channel,
            timeframe: {
              fromTime: this.cardsTime.timeframe.from,
              toTime: this.cardsTime.timeframe.to
            },
            compareTo:
              this.cardsTime.compareTo.from && this.cardsTime.compareTo.to
                ? {
                    fromTime: this.cardsTime.compareTo.from,
                    toTime: this.cardsTime.compareTo.to
                  }
                : undefined
          }
        };
      },
      fetchPolicy: "network-only",
      update(data) {
        let i = 0;
        this.sourceStatsDataset = {
          datasets: data.fractionalDashboardStats.data.map(x => {
            x.backgroundColor = colorFromLabel(
              data.fractionalDashboardStats.labels[Math.floor(i / 2)]
            );
            x.hoverBackgroundColor = colorFromLabel(
              data.fractionalDashboardStats.labels[Math.floor(i / 2)]
            );
            x.stack = String(x.stack);
            x.transform =
              this.filter.channel == "CTR"
                ? transformWithoutUnit
                : transformWithUnit;
            i++;
            return x;
          }),
          labels: data.fractionalDashboardStats.labels
        };
      }
    }
  }
};

function transformWithUnit(value) {
  return Number(value).toLocaleString("de-DE", {
    style: "currency",
    currency: "eur"
  });
}

function transformWithoutUnit(value) {
  return Number(value).toLocaleString("de-DE", {
    style: "decimal",
    maximumFractionDigits: 3
  });
}

function colorFromLabel(label, alpha = 1) {
  const colors = {
    Cleverreach: "#ec6702",
    Facebook: "#4267B2",
    Google: "#DB4437"
  };
  if (colors[label]) {
    return colors[label];
  }
  return color.colorFromString(label, alpha);
}
</script>

<style lang="scss">
@import "@/assets/scss/components/bi/main";

.vue-back-to-top {
  bottom: 8% !important;
}
</style>
